export default __webpack_public_path__ + "static/media/Ficha técnica.4d3b09a0.svg";